import { Box } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { path } from "src/constants/path";
import { dataStateType } from "src/constants/status";
import { accessControlColumns as columns } from "../../Helper";

const GetAccessControlTableColumn = ({
  handleOpenPopup,
  handleDelete,
  status,
}) => {
  const history = useHistory();
  const showAccessListDetail = (accessControl) => {
    history.push(`${path.systemAccessControl}/${accessControl.id}`);
  };
  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        <button
          onClick={() => {
            handleOpenPopup(null, item.route, item.id);
          }}
          className="btn btn-primary"
        >
          <i className="bx bx-plus"></i>
        </button>
        <button
          onClick={() => {
            showAccessListDetail(item);
          }}
          className="btn btn-success"
        >
          <i className="bx bx-show"></i>
        </button>
        <button
          onClick={() => handleOpenPopup(item, "", "")}
          className="btn btn-warning"
        >
          <i className="bx bx-edit"></i>
        </button>
        <button
          onClick={() => handleDelete(item.id)}
          className="btn btn-danger"
        >
          <i className="bx bx-trash"></i>
        </button>
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, actionCol];
  }

  return columns;
};

export default GetAccessControlTableColumn;
